import Marquee from './Marquee';

export type { MarqueeProps } from './Marquee';

export default Marquee;
